import React from 'react'
import { connect } from "react-redux";
import { SetUploadFileErr, SetDepositNextStep, PostConfirmStep, SetDepositSuccessPage, PostMemberCancelDeposit } from '$Deposits/store/actions/DepositAction'



class NextStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            payModals: false,
        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {

        const {
            DepositPayments,
            MethodsActive,
            DepositMoneyStatus,
            NextStep,
            MethodCodeActive,
            UploadFileErr,
            SetUploadFileErr,
            FileModal,
            Modal,
            PayModal,
            SetDepositSuccessPage,
            PostConfirmStep,
            PostMemberCancelDeposit,
            SetDepositNextStep,
        } = this.props
        const { qrDeepLink, isDummyBank = false } = DepositPayments || {}

        return (
            <>
                <Modal
                    modalVisible={!Boolean(qrDeepLink) || isDummyBank}
                    title={isDummyBank ? 'Gửi Tiền Thất Bại!' : 'Lỗi Đường Truyền'}
                    okText={'Thực Hiện Lại'}
                    msg={isDummyBank ? 'Chúng tôi rất tiếc hiện tại không có ngân hàng khả dụng . Giao dịch này sẽ bị hủy, Bạn vui lòng chọn phương thức gửi tiền khác.' : (!Boolean(qrDeepLink) && 'Lỗi đường truyền vui lòng thực hiện lại giao dịch')}
                    onChange={() => { PostMemberCancelDeposit() }}
                    onlyOkBtn={true}
                    modes={isDummyBank ? 'warning' : 'frame'}
                />
                {/* <FileModal
                    modalVisible={Boolean(UploadFileErr)}
                    title={'Tải Lên Thất Bại!'}
                    okText={'Tôi Hiểu'}
                    msg={UploadFileErr}
                    onChange={() => { SetUploadFileErr('') }}
                /> */}
                <NextStep
                    DepositPayments={DepositPayments}
                    MethodsActive={MethodsActive}
                    MethodCodeActive={MethodCodeActive}
                    backClick={() => { 
                        PostMemberCancelDeposit()
                     }}
                    onChange={() => {
                        PostConfirmStep(DepositPayments || {})
                        SetDepositSuccessPage(true)
                    }}
                    DepositMoneyStatus={DepositMoneyStatus}
                />


            </>
        );
    }
}

const mapStateToProps = state => ({
    DepositMoneyStatus: state.DepositMoneyStatus,
    MethodsActive: state.MethodsActive,
    DepositPayments: state.DepositPayments,
    MethodCodeActive: state.MethodCodeActive,
    UploadFileErr: state.UploadFileErr,
});
const mapDispatchToProps = {
    SetUploadFileErr: (data = '') => SetUploadFileErr(data),
    SetDepositNextStep: (data = false) => SetDepositNextStep(data),
    PostConfirmStep: (data = {}) => PostConfirmStep(data),
    PostMemberCancelDeposit: () => PostMemberCancelDeposit(),
    SetDepositSuccessPage: (data = false) => SetDepositSuccessPage(data)
};
export default connect(mapStateToProps, mapDispatchToProps)(NextStep);

